import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";

const TokenInfoBox = (): JSX.Element => {
  return (
    <Stack className="al-bg-blue-50 al-p-4 al-rounded">
      <Typography weight="regular" size="sm">
        Generate dbt Cloud Service Token
      </Typography>
      <Typography size="sm">
        Navigate to Account Settings in dbt Cloud and create a new Service Token under Service
        Tokens. For more information, visit{" "}
        <a
          href="https://docs.getdbt.com/docs/dbt-cloud-apis/service-tokens"
          target="_blank"
          rel="noopener noreferrer"
          className="al-text-primary al-underline"
        >
          dbt Docs
        </a>
      </Typography>
    </Stack>
  );
};

export default TokenInfoBox;
